var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"brw"},[_c('p',[_vm._v(_vm._s(_vm.$ml.get('pixOFOrderReviewRedirectWarning1'))),_c('strong',{domProps:{"textContent":_vm._s(_vm.selectedBank.organizationName)}}),_vm._v(_vm._s(_vm.$ml.get('pixOFOrderReviewRedirectWarning2')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }